<ul>
  {#each bottomLinks as link}
    <li>
      <FooterBottomLink {colorClassNames} {...link} />
    </li>
  {/each}
</ul>

<style lang="less">
  @import (reference) '../../../less/variables';

  ul {
    margin: 0 @masthead-gutter-width * 3 0 0;
    padding: 0 0 0 @masthead-gutter-width;
  }

  li {
    list-style: none;
    display: inline-block;
    margin-right: 24px;

    /*
     * The additional styles below
     * override encore-web global
     * styles
     */
    padding: 0;
    line-height: normal;
    letter-spacing: 0;
  }
</style>

<script>
  import FooterBottomLink from './FooterBottomLink.html';

  export let bottomLinks;
  export let colorClassNames;
</script>
